import React, { useState, createContext } from "react";
import { getOtp } from "../../../../apis/Api";
import { useNavigate, useLocation } from "react-router-dom";
import RouteConstant from "../../../../constants/routesContent.json";
import LoginConstants from "../../../../constants/contentFile.json";
import { validateRegesterdMobileNumber } from "../../../../utils/service";

export const LoginMobileNumberContext = createContext({});
export const LoginMobileNumberContextProvider = ({ children }) => {
  const [regMobileNumber, setRegMobileNumber] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const loginContent = LoginConstants.errorMessages;
  const navigate = useNavigate();
  const location = useLocation();
  const token = location.state;
  const [apiStatus, setApiStatus] = useState('');

  const onSubmitClik = async () => {
    if (
      regMobileNumber.toString().length == 10 &&
      validateRegesterdMobileNumber(regMobileNumber)
    ) {
      setApiStatus('fetching');
      try {
        const getOtpData = await getOtp(regMobileNumber, token);
        if (getOtpData?.data?.statusCode == 200) {
          navigate(RouteConstant.LOGIN_ENTER_OTP, {
            state: {
              regMobileNumber: regMobileNumber,
              isOtpSuccess: true,
              token: token,
            },
          });
        }
      } catch (error) {
        if (error?.response?.data?.statusCode === 400) {
          const errorMessage = error.response.data.statusMessage;
          navigate(RouteConstant.LINK_EXPIRED, { state: errorMessage });
        } else {
          setAlertMessage(loginContent.somethingWrong);
          setShowAlert(true);
        }
      }
      setApiStatus('completed');
    } else {
      setShowAlert(true);
      setAlertMessage(loginContent.enterValidNumber);
    }
  };
  const providerValue = {
    setRegMobileNumber,
    onSubmitClik,
    showAlert,
    setShowAlert,
    regMobileNumber,
    alertMessage,
    apiStatus
  };
  return (
    <LoginMobileNumberContext.Provider value={providerValue}>
      {children}
    </LoginMobileNumberContext.Provider>
  );
};
